const INITIAL_STATE = {
  allCompany: [],
  allCompanyNames: [],
  allDepartments: [],
  allDepartmentNames: [],
  allPositions: [],
  allPositionNames: [],
  allEmployees: [],
  allAdmins: [],
  allMeetingRooms: [],
  allEmployeesMails: [],
  allMeetingRoomNames: [],
  allMeetings: [],
  adminLogged: 1,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ALLCOMPANY":
      return { ...state, allCompany: action.payload };

    case "SET_ALLCOMPANYNAMES":
      return { ...state, allCompanyNames: action.payload };

    case "SET_ALLDEPARTMENS":
      return { ...state, allDepartments: action.payload };

    case "SET_ALLDEPARTMENTNAMES":
      return { ...state, allDepartmentNames: action.payload };

    case "SET_ALLPOSITIONS":
      return { ...state, allPositions: action.payload };

    case "SET_ALLPOSITIONNAMES":
      return { ...state, allPositionNames: action.payload };

    case "SET_ALLEMPLOYEES":
      return { ...state, allEmployees: action.payload };

    case "SET_ALLADMINS":
      return { ...state, allAdmins: action.payload };

    case "SET_ALLMEETINGROOMS":
      return { ...state, allMeetingRooms: action.payload };

    case "SET_ALLEMPLOYEESMAILS":
      return { ...state, allEmployeesMails: action.payload };

    case "SET_ALLMEETINGROOMNAMES":
      return { ...state, allMeetingRoomNames: action.payload };

    case "SET_ALLMEETINGS":
      return { ...state, allMeetings: action.payload };

    case "SET_ADMINLOGGEDTRIGGER":
      return { ...state, adminLogged: action.payload };

    default:
      return state;
  }
};
